produtos.component('produtos.certificadoComponent', {
    templateUrl: 'produtos/produtoDetalhes/certificado/certificado.html',
    controller: 'produtos.certificadoController',
    bindings: { baseProduto: '<' }
});

produtos.controller('produtos.certificadoController', ['$scope', '$element', '$state', '$filter', 'coreToast', 'coreFb', 'coreLanguage', function ($scope, $element, $state, $filter, $toast, $fb, $text) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.formData = {};
    $ctrl.certificadoData = {
        'certificado.textSize': 0,
        'certificado.posY': 0,
        'certificado.posX': 0
    };

    $ctrl.imagemState = {
        isSubmiting: false,
        submitError: '',
        submitSuccess: false
    };

    $ctrl.submitImagem = () => {
        $ctrl.imagemState.isSubmiting = true;
        $ctrl.imagemState.submitError = false;
        $ctrl.imagemState.submitSuccess = false;

        $ctrl.certificadoData['certificado.imgUrl'] = null;

        $ctrl.canvasImage = null;

        $fb.storage.upload(`/produtos/${$ctrl.produtoId}/certificado`, $ctrl.formData.imgUrl[0]).then((url) => {
            $ctrl.certificadoData['certificado.imgUrl'] = url;

            $ctrl.renderCanvas();

            $scope.certificadoCadadastroForm['certificado.imgUrl'].$setDirty();
        }).catch((e) => {
            $ctrl.imagemState.submitError = true;

            throw e;
        }).finally(() => {
            $ctrl.imagemState.isSubmiting = false;
        })
    }

    $ctrl.getModifiedCertificadoData = () => {
        const modifiedData = {};

        Object.keys($ctrl.certificadoData).forEach(name => {
            if ($scope.certificadoCadadastroForm[name].$dirty) {
                modifiedData[name] = $ctrl.certificadoData[name];
            }
        })

        return modifiedData;
    }

    $ctrl.submitCertificadoForm = () => {
        if (!$scope.certificadoCadadastroForm.$valid) {
            $ctrl.validateInfoFields();
            return
        }

        if ($ctrl.imagemState.isSubmiting) {
            return
        }

        $ctrl.formErrors = {};

        $ctrl.isSubmiting = true;
        $ctrl.submitError = '';
        $ctrl.submitSuccess = false;

        const certificadoData = $ctrl.getModifiedCertificadoData();
        $fb.db.update(`/cad_produtos/${$ctrl.produtoId}`, certificadoData).then(() => {
            $scope.certificadoCadadastroForm.$setPristine();

            $toast.success('O produto foi alterado.');
            $scope.$emit('update-produto');
        }).catch(e => {
            $ctrl.submitError = 'internal';

            throw e;
        }).finally(() => {
            $ctrl.isSubmiting = false;
        })
    }

    $ctrl.cleanCertificado=()=>{
        $ctrl.isSubmiting = true;

        $fb.db.update(`/cad_produtos/${$ctrl.produtoId}`, {certificado:{}}).then(() => {
            $state.reload();
        });
    };

    $ctrl.canvasElement = null;
    $ctrl.canvasImage = null;

    $ctrl.renderCanvas = () => {
        if (!$ctrl.certificadoData['certificado.imgUrl']) {
            return
        }

        const renderElements = () => {
            const canvasContext = $ctrl.canvasElement.getContext('2d');

            const canvasWidth = $ctrl.canvasImage.width;
            const canvasHeight = $ctrl.canvasImage.height * 1.04;

            canvasContext.canvas.width = canvasWidth;
            canvasContext.canvas.height = canvasHeight;

            canvasContext.fillStyle = 'black';
            canvasContext.fillRect(0, 0, canvasWidth, canvasHeight);

            canvasContext.drawImage($ctrl.canvasImage, 0, 0);

            canvasContext.fillStyle = 'white';
            canvasContext.textBaseline = 'bottom';
            canvasContext.textAlign = 'center';
            canvasContext.font = `${$ctrl.canvasImage.height * .02}px Montserrat`;

            const dataAtual = $filter('date')(new Date(), 'dd/MM/yy');
            const footerMessage = `Emitido em ${dataAtual} por Hype Class`;
            canvasContext.fillText(footerMessage, canvasWidth * .5, canvasHeight * 0.99);

            canvasContext.fillStyle = $ctrl.certificadoData['certificado.textColor'];
            canvasContext.textBaseline = $ctrl.certificadoData['certificado.textBaseline'];
            canvasContext.textAlign = $ctrl.certificadoData['certificado.textAlign'];

            const relativeTextSize = $ctrl.canvasImage.width * $ctrl.certificadoData['certificado.textSize'] * .0015;
            const relativePosX = $ctrl.canvasImage.width * $ctrl.certificadoData['certificado.posX'] * .01;
            const relativePosY = $ctrl.canvasImage.height * $ctrl.certificadoData['certificado.posY'] * .01;

            canvasContext.font = `${relativeTextSize}px Montserrat`;
            canvasContext.fillText($ctrl.baseProduto.data.nome, relativePosX, relativePosY);
        }

        if ($ctrl.canvasImage) {
            renderElements();

            return
        }

        $ctrl.canvasImage = new Image();
        $ctrl.canvasImage.addEventListener('load', renderElements, false);
        $ctrl.canvasImage.src = $ctrl.certificadoData['certificado.imgUrl'];
    }

    $ctrl.onImagemChanged = () => {
        if (!$ctrl.formData.imgUrl) {
            return
        }

        if (!$ctrl.formData.imgUrl[0]) {
            $ctrl.formData.imgUrl = null;
            return
        }

        $ctrl.submitImagem();
    }

    $ctrl.$onInit = () => {
        $state.params.salvarPendente = () => $scope.certificadoCadadastroForm.$dirty;

        $ctrl.canvasElement = $element[0].querySelector('.certificado-container');

        $ctrl.deregisterOnImagemChanged = $scope.$watch('$ctrl.formData.imgUrl', $ctrl.onImagemChanged)

        $ctrl.deregisterOnCertificadoDataChanged = $scope.$watchCollection('$ctrl.certificadoData', () => {
            $ctrl.renderCanvas();
        });
    }

    $ctrl.$onChanges = (changes) => {
        if (changes.baseProduto && changes.baseProduto.currentValue) {
            $ctrl.produtoId = $ctrl.baseProduto.id;

            const baseProduto = changes.baseProduto.currentValue;
            $ctrl.certificadoData = {
                'certificado.textSize': baseProduto.data.certificado?.textSize ?? 50,
                'certificado.textColor': baseProduto.data.certificado?.textColor ?? '#000000',
                'certificado.textBaseline': baseProduto.data.certificado?.textBaseline ?? 'middle',
                'certificado.textAlign': baseProduto.data.certificado?.textAlign ?? 'center',
                'certificado.posY': baseProduto.data.certificado?.posY ?? 50,
                'certificado.posX': baseProduto.data.certificado?.posX ?? 50,
                'certificado.imgUrl': baseProduto.data.certificado?.imgUrl
            };

            $ctrl.renderCanvas();
        }
    }
}])